import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { formatApiError } from '@/lib/api';
import { AUTH } from '@/constants/testIds';
import { Sparkles } from 'lucide-react';

export default function RegisterPage() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: '', email: '', phone: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      await register(form);
      navigate('/nalog');
    } catch (e) {
      setError(formatApiError(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-[80vh] flex items-center aurora-bg grain">
      <div className="container-x py-16 max-w-md mx-auto">
        <div className="bg-white border border-slate-200 rounded-3xl p-8 shadow-sm">
          <div className="inline-flex items-center gap-2 font-display font-extrabold text-xl">
            <span className="inline-flex h-9 w-9 items-center justify-center rounded-2xl text-white"
              style={{ background: 'linear-gradient(135deg, #059669 0%, #5B21B6 100%)' }}>
              <Sparkles className="w-5 h-5" />
            </span>
            Dubinko
          </div>
          <h1 className="font-display text-3xl font-bold mt-4">Napravite nalog</h1>
          <p className="text-slate-600 mt-1">Zakazivanje i istorija postaju jednostavniji.</p>

          <form onSubmit={submit} className="mt-6 space-y-4" data-testid={AUTH.registerForm}>
            <div>
              <label className="block text-sm font-semibold text-slate-700 mb-2">Ime i prezime</label>
              <input data-testid={AUTH.registerName} required value={form.name}
                onChange={(e) => setForm({...form, name: e.target.value})}
                className="w-full px-4 py-3 rounded-2xl border border-slate-300 outline-none focus:border-blue-700" />
            </div>
            <div>
              <label className="block text-sm font-semibold text-slate-700 mb-2">Email</label>
              <input data-testid={AUTH.registerEmail} type="email" required value={form.email}
                onChange={(e) => setForm({...form, email: e.target.value})}
                className="w-full px-4 py-3 rounded-2xl border border-slate-300 outline-none focus:border-blue-700" />
            </div>
            <div>
              <label className="block text-sm font-semibold text-slate-700 mb-2">Telefon</label>
              <input data-testid={AUTH.registerPhone} value={form.phone}
                onChange={(e) => setForm({...form, phone: e.target.value})}
                placeholder="+381 ..." className="w-full px-4 py-3 rounded-2xl border border-slate-300 outline-none focus:border-blue-700" />
            </div>
            <div>
              <label className="block text-sm font-semibold text-slate-700 mb-2">Lozinka (min. 6)</label>
              <input data-testid={AUTH.registerPassword} type="password" required minLength={6}
                value={form.password} onChange={(e) => setForm({...form, password: e.target.value})}
                className="w-full px-4 py-3 rounded-2xl border border-slate-300 outline-none focus:border-blue-700" />
            </div>
            {error && <div data-testid={AUTH.errorMessage} className="px-4 py-3 rounded-xl bg-red-50 text-red-700 text-sm">{error}</div>}
            <button data-testid={AUTH.registerSubmit} type="submit" disabled={loading}
              className="w-full btn-primary py-3 rounded-full font-semibold disabled:opacity-60">
              {loading ? 'Registrujem…' : 'Kreiraj nalog'}
            </button>
          </form>

          <div className="text-center text-sm text-slate-600 mt-5">
            Već imate nalog?{' '}
            <Link to="/prijava" className="font-semibold text-blue-700 hover:underline">Prijavite se</Link>
          </div>
        </div>
      </div>
    </main>
  );
}
